module.exports = __webpack_public_path__ + "static/media/ssoLogin.32ee1f32.png";